import { z } from "zod";
import { REVIEW_TEXT_MIN, REVIEW_TEXT_MAX, REVIEW_REPLY_MAX } from "@/lib/review-limits";

export const createReviewSchema = z.object({
  therapistId: z.string().min(1),
  rating: z.number().int().min(1).max(5),
  reviewText: z
    .string()
    .trim()
    .min(REVIEW_TEXT_MIN, `Recenzija mora imati barem ${REVIEW_TEXT_MIN} znakova.`)
    .max(REVIEW_TEXT_MAX, `Recenzija ne smije biti duža od ${REVIEW_TEXT_MAX} znakova.`),
  isAnonymous: z.boolean().optional().default(false),
});

export const therapistReplySchema = z.object({
  reply: z
    .string()
    .trim()
    .min(1, "Odgovor ne smije biti prazan.")
    .max(REVIEW_REPLY_MAX, `Odgovor ne smije biti duži od ${REVIEW_REPLY_MAX} znakova.`),
});

export const REVIEW_REJECTION_REASON_MAX = 500;

// No REVIEW_TEXT_MIN here: the minimum is a rule for clients writing a review,
// and a few existing reviews are shorter. Moderating one must not be blocked.
export const adminEditReviewSchema = z.object({
  reviewText: z
    .string()
    .trim()
    .min(1, "Tekst recenzije ne smije biti prazan.")
    .max(REVIEW_TEXT_MAX, `Recenzija ne smije biti duža od ${REVIEW_TEXT_MAX} znakova.`)
    .optional(),
  rating: z.number().int().min(1).max(5).optional(),
}).refine((v) => v.reviewText !== undefined || v.rating !== undefined, {
  message: "Mora se promijeniti barem jedno polje.",
});

export const adminRejectSchema = z.object({
  rejectionReason: z
    .string({ error: "Upišite razlog odbijanja." })
    .trim()
    .min(1, "Upišite razlog odbijanja.")
    .max(
      REVIEW_REJECTION_REASON_MAX,
      `Razlog odbijanja ne smije biti duži od ${REVIEW_REJECTION_REASON_MAX} znakova.`,
    ),
});

export type CreateReviewInput = z.infer<typeof createReviewSchema>;
export type TherapistReplyInput = z.infer<typeof therapistReplySchema>;
export type AdminEditReviewInput = z.infer<typeof adminEditReviewSchema>;
export type AdminRejectInput = z.infer<typeof adminRejectSchema>;
